import {TAG_TYPE__MO} from '../../common/constants/Tags.js'
import {
  addTagToMOs,
  removeTagFromMOs,
  moTagOptionsSelector,
  moTagOptionTokensSelector,
} from '../../data/moTags.js'
import {
  hasMOManageTagPermissionSelector,
  hasMOManageTagOnMOPermissionSelector,
} from '../../data/me.js'
import ManageTagFilter from '../../common/components/ManageTagFilter.js'
import {createAndApplyTagToMOs} from './moListActions.js'
import {createMOTagQuantityMapSelector} from './moListSelectors.js'
import {useSelector} from '../../store.js'
import {useMemo} from 'react'

/**
 * AddMOTagsDropdown component
 *
 * @param {Object} props - The component props.
 * @param {Array} props.referenceIDs - The reference IDs of the MOs to which tags will be applied.
 *
 * @returns
 */
export default function AddMOTagsDropdown({referenceIDs}) {
  const moTagQuantityMapSelector = useMemo(
    () => createMOTagQuantityMapSelector(),
    [],
  )

  const moTagOptions = useSelector(moTagOptionsSelector)
  const moTagOptionTokens = useSelector(moTagOptionTokensSelector)
  const tagQuantityMap = useSelector((state) =>
    moTagQuantityMapSelector(state, {referenceIDs}),
  )
  const hasMOManageTagPermission = useSelector(hasMOManageTagPermissionSelector)
  const hasMOManageTagOnMOPermission = useSelector(
    hasMOManageTagOnMOPermissionSelector,
  )

  if (!hasMOManageTagOnMOPermission) {
    return null
  }

  return (
    <li className="inline-block margin-left-10">
      <ManageTagFilter
        dropdown="APPLY_MO_TAG_FILTER"
        onSelect={(tag) => {
          if (tagQuantityMap[tag.id] === 'all') {
            removeTagFromMOs(tag.id, referenceIDs)
          } else {
            addTagToMOs(tag.id, referenceIDs)
          }
        }}
        tagOptions={moTagOptions}
        tagOptionTokens={moTagOptionTokens}
        tagQuantityMap={tagQuantityMap}
        hasManageTagPermission={hasMOManageTagPermission}
        tagType={TAG_TYPE__MO}
        onCreateAndApplyClick={() => createAndApplyTagToMOs(referenceIDs)}
      />
    </li>
  )
}
